'use strict';

angular.module('ecrd.sites', [
    'sharecrf-sdk',
]);
